import { useQuery } from 'react-query';

import { getSubProgramPreferenceP6ExcelExport as queryFn } from 'api/endPoints/getSubProgramPreferenceP6ExcelExport';

export const useQueryGetExcelExportConfig = ({ subProgramId }) => {
    return useQuery<IGetExcelExportConfig, QueryError>(
        ['useQueryGetExcelExportConfig', subProgramId],
        () => queryFn(subProgramId),
        {
            enabled: Boolean(subProgramId),
        },
    );
};

interface IGetExcelExportConfig {
    isExtractRemainingDuration: boolean;
    isExtractPercentageComplete: boolean;
    userData: string;
}
